import { render } from "./TinyPumperToday.vue?vue&type=template&id=52ddffb0"
import script from "./TinyPumperToday.vue?vue&type=script&lang=js"
export * from "./TinyPumperToday.vue?vue&type=script&lang=js"

import "./TinyPumperToday.vue?vue&type=style&index=0&id=52ddffb0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__